import { type PreorderState } from "./state.ts";
import { type WearLookup } from "./words.server.ts";

type Rejection = Extract<WearLookup, { rejected: unknown }>["rejected"];

/** What the picker says when `?word=` can't go on the jersey (Story 3). */
export function rejectionMessage({ term, reason }: Rejection): string {
  switch (reason) {
    case "too-long":
      return `${term} is too long for the back of the jersey: 12 letters at most. Pick another word.`;
    case "characters":
      return `${term} has characters we can't print. Pick another word.`;
    case "not-printable":
      return `${term} can't go on the jersey. Pick another word.`;
    case "not-published":
      return `${term} isn't published in the dictionary yet. Pick another word.`;
    case "not-found":
      return "We couldn't find that word. Pick one from the list.";
  }
}

export type PreorderAction = {
  enabled: boolean;
  label: string;
  reason?: string;
};

/** The pre-order button: live only when pre-orders are open and a word is chosen (Stories 4 and 5). */
export function preorderAction(
  state: PreorderState,
  hasWord: boolean,
): PreorderAction {
  if (state === "upcoming") {
    const text = "Pre-orders open Sat 14 Nov";
    return { enabled: false, label: text, reason: text };
  }
  if (state === "closed") {
    const text = "Pre-orders closed";
    return { enabled: false, label: text, reason: text };
  }
  return hasWord
    ? { enabled: true, label: "Pre-order" }
    : { enabled: false, label: "Pre-order", reason: "Pick a word first" };
}
